<template>
    <div class="w-[100px] h-[12px] rounded-full bg-white-foreground/20 animate-pulse"></div>
</template>
